import realcousin from "./component/assets/realcousin.png";
import manager from "./component/assets/manage.png";
import chatter from "./component/assets/chatter.png";
import andrilla from "./component/assets/andrilla.png";
import gtube from "./component/assets/gospeltube.png"
import bionofitsa from "./component/assets/bionatfisAlogo.png"

export const FrontEndJobs = [
  {
    id: 1,
    title: "Bionafithsa",
    image: bionofitsa,
    url: "https://bio-nafitha.vercel.app/",
    description:
      "This is a modern and fully responsive e-commerce application built using Next.js, TypeScript, and Chakra UI. The application offers a seamless shopping experience with optimized performance, server-side rendering, and a user-friendly interface. Designed with scalability in mind, it leverages the power of TypeScript for robust type safety and Chakra UI for an elegant and customizable design system. The app provides features such as dynamic product listings, intuitive navigation, and a responsive layout to ensure a smooth experience across all devices.",
  },
  {
    id: 2,
    title: "G-tube",
    image: gtube,
    url: "https://radiant-cat-8e67b7.netlify.app/",
    description:
      "This is a feature-rich streaming platform dedicated to gospel programs, music, and videos, providing users with a seamless way to watch, listen, and engage with faith-based content. The platform also enables users to host live programs and events, fostering a vibrant online community. Built with React.js, TypeScript, Chakra UI, and Tailwind CSS, the application ensures a modern, responsive, and visually appealing user experience. With a focus on performance, accessibility, and scalability, this platform delivers a smooth and immersive streaming experience across all devices.",
  },
  {
    id: 3,
    title: "RealCousin",
    image: realcousin,
    url: "https://radiant-cat-8e67b7.netlify.app/",
    description:
      "Real cousin is an app that connects family, the aim of of the app is to keep relationship betewwen families and friend, its a project i took to work on to ehnace my front end skills. Technologies used : Html, Css, Javascript, Fontawesome and Goodle fonts",
  },
  {
    id: 4,
    title: "Chatter App",
    image: chatter,
    url: "https://chatter-app-git-main-micheals-projects-33a0e733.vercel.app/",
    description:
      "This is a demo application built to test, refine, and expand my React skills through hands-on development. It serves as a learning platform for experimenting with React, TypeScript, Chakra UI, Tailwind CSS, and Styled Components, allowing me to explore modern front-end development techniques. The project focuses on improving state management, UI design, and component reusability, while also enhancing my understanding of scalable and maintainable code structures",
  },

  {
    id: 5,
    title: "Andrilla",
    image: andrilla,
    url: "https://bejewelled-paletas-7ab287.netlify.app/",
    description:
      "This is a demo application built to test, refine, and expand my Vue js skills through hands-on development. It serves as a learning platform for experimenting with Vue js, Javascript, and Styled Components, allowing me to explore modern front-end development techniques. The project focuses on improving state management, UI design, and component reusability, while also enhancing my understanding of scalable and maintainable code structures",
  },
  {
    id: 4,
    title: "Manager",
    image: manager,
    url: "https://clinquant-zabaione-9f9c16.netlify.app/",
    description:
      "",
  },
];
